import { useEffect } from 'react';

const useSEO = ({ title, description, keywords, schema }) => {
  useEffect(() => {
    if (title) {
      document.title = `${title} | Dfitclub by Deeksha Rajput`;
    } else {
      document.title = 'Dfitclub - Health & Nutrition Transformation';
    }
    
    // Update description meta tag
    const descMeta = document.querySelector('meta[name="description"]');
    if (descMeta) {
      descMeta.setAttribute('content', description || 'Transform your health with personalized weight loss and weight gain programs by expert clinical nutritionist Deeksha Rajput. Expert nutrition guidance, healthy recipes, and proven results.');
    }

    // Update keywords meta tag
    const keywordsMeta = document.querySelector('meta[name="keywords"]');
    if (keywordsMeta) {
      keywordsMeta.setAttribute('content', keywords || 'weight loss, weight gain, nutrition, diet plans, healthy recipes, fitness, transformation, Deeksha Rajput');
    }

    // Handle JSON-LD Schema
    const oldSchema = document.getElementById('jsonld-schema');
    if (oldSchema) {
      oldSchema.remove();
    }

    if (schema) {
      const schemaScript = document.createElement('script');
      schemaScript.id = 'jsonld-schema';
      schemaScript.type = 'application/ld+json';
      schemaScript.text = JSON.stringify(schema);
      document.head.appendChild(schemaScript);
    }

    return () => {
      // Clean up schema on unmount
      const existingSchema = document.getElementById('jsonld-schema');
      if (existingSchema) {
        existingSchema.remove();
      }
    };
  }, [title, description, keywords, schema]);
};

export default useSEO;
